import { render, staticRenderFns } from "./privacyModal.vue?vue&type=template&id=0559059a&"
import script from "./privacyModal.vue?vue&type=script&lang=js&"
export * from "./privacyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports